import type { Meta, StoryFn } from '@storybook/react';
import type { AccordionProps } from './Accordion';

import { Accordion } from './Accordion';

import { Container } from 'storyComponents/Container';

const codeString = '<Accordion title={title} content={content}/>';

// eslint-disable-next-line import/no-default-export
export default {
  title: 'Atoms/Accordion',
  component: Accordion,
  argTypes: {
    expanded: {
      // Hide the expanded prop. Changing the value in Storybook doesn't update the state of the component.
      table: {
        disable: true,
      },
    },
  },
  parameters: {
    inspectComponent: Accordion,
    codeString: codeString,
  },
} as Meta<AccordionProps>;

const Template: StoryFn<AccordionProps> = (args) => (
  <Container>
    <Accordion {...args} />
  </Container>
);

export const AccordionExample = Template.bind({});
AccordionExample.args = {
  title: 'Example title',
  content: 'Example content',
};

export const WithComplexProps = Template.bind({});
WithComplexProps.args = {
  title: <div style={{ fontWeight: 'bold' }}>Complex sample title</div>,
  content: <div style={{ fontStyle: 'italic' }}>Complex sample content</div>,
};
